import {computed} from 'vue';

import type {IRecipient} from '@/api/types/recipient';

import type {IAntSelectOption} from '@/assets/ant/select/types';

import {recipientDefault} from '@/api/defaults/recipient';

import {parseOffsetByIANATimezone} from '@/assets/core/assets/helpers/time';

export const useRecipientPresenterHook = (item?: Partial<IRecipient>) => {
  const getItem = computed(() => (item ? item : recipientDefault));

  const getId = computed(() => getItem.value.id);
  const getName = computed(() => getItem.value.name);
  const getUsername = computed(() => getItem.value.username);
  const getType = computed(() => getItem.value.type);
  const getIsEnabled = computed(() => getItem.value.is_enabled ?? true);

  const getEmails = computed(() => getItem.value.emails);
  const getTelegrams = computed(() => getItem.value.telegrams);

  const getOption = computed<IAntSelectOption>(() => {
    return {label: getItem.value.name, value: getItem.value.id};
  });

  const getTimezone = computed(() => getItem.value.timezone ?? 'Europe/Moscow');

  const getTimezoneOffset = computed(() =>
    parseOffsetByIANATimezone(getTimezone.value),
  );

  const getViewRolesMap = computed(() => getItem.value.view_roles_map ?? []);

  const getViewRolesMapNames = computed(() =>
    getViewRolesMap.value.length > 0
      ? getViewRolesMap.value.map((r) => r.name).join(', ')
      : 'н/д',
  );

  return {
    getItem,

    getId,

    getName,
    getUsername,
    getType,
    getIsEnabled,

    getEmails,
    getTelegrams,

    getOption,

    getTimezone,
    getTimezoneOffset,

    getViewRolesMap,
    getViewRolesMapNames,
  };
};

export const useTimezonePresenterHook = (item: string) => {
  const getOption = computed<IAntSelectOption>(() => ({
    label: parseOffsetByIANATimezone(item),
    value: item,
  }));

  return {
    getOption,
  };
};
